import { render, staticRenderFns } from "./StudentsTableColumn.vue?vue&type=template&id=c8b78bde&scoped=true&"
import script from "./StudentsTableColumn.vue?vue&type=script&lang=js&"
export * from "./StudentsTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./StudentsTableColumn.vue?vue&type=style&index=0&id=c8b78bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b78bde",
  null
  
)

export default component.exports